enum LisioBroadcastChannelNames {
  READER = "reader",
}

export default LisioBroadcastChannelNames;
